// extracted by mini-css-extract-plugin
export default {"stonesList":"style_stonesList__Zq4g-","stoneBlock":"style_stoneBlock__bsgJX","imgBlock":"style_imgBlock__3Niur","circle":"style_circle__2HuHY","ok":"style_ok__z07Qz"};